import { LocalDate } from "@js-joda/core";
import React from "react";
import { SubmitHandler, useForm } from "react-hook-form";
import { STRINGS } from "../../../strings";
import { translate } from "../../../translate";
import { AppBottomSheet } from "../../Generic/AppBottomSheet";
import { AppButton } from "../../Generic/AppButton";
import { AppListTitle } from "../../Generic/AppList";
import Flex from "../../Generic/Flex";
import Question from "../../OnboardingSection/Question";
import ComplianceDocumentActivity from "./ComplianceDocumentActivity";

interface Props {
  isOpen: boolean;
  isLoading: boolean;
  expiryDate: LocalDate | null;
  onClickSave: (expirationDate: LocalDate | null) => void;
  onClickClose: () => void;
}

interface Inputs {
  expiryDate: string;
}

function SetExpiryDateComplianceDocumentModal(props: Props) {
  const { register, handleSubmit } = useForm<Inputs>({
    defaultValues: {
      expiryDate: props.expiryDate?.toString(),
    },
  });

  const onSubmit: SubmitHandler<Inputs> = (data) => {
    const expiryDate = (() => {
      if (data.expiryDate === "") {
        return null;
      }

      try {
        return LocalDate.parse(data.expiryDate);
      } catch (e) {
        console.error(e);
        return null;
      }
    })();

    props.onClickSave(expiryDate);
  };

  return (
    <AppBottomSheet isOpen={props.isOpen} rounded={true} onRequestClose={props.onClickClose}>
      <AppListTitle>{`What's the expiry date?`}</AppListTitle>
      <Flex direction="column" yGap={8}>
        <Question.Date {...register("expiryDate")} />
        <ComplianceDocumentActivity.ModalButtonsWrapper>
          <form onSubmit={handleSubmit(onSubmit)}>
            <AppButton variant="filled" color="primary" isLoading={props.isLoading}>
              {translate(STRINGS.SAVE)}
            </AppButton>
          </form>
          <AppButton variant="outline" color="black" onClick={props.onClickClose}>
            {translate(STRINGS.CANCEL)}
          </AppButton>
        </ComplianceDocumentActivity.ModalButtonsWrapper>
      </Flex>
    </AppBottomSheet>
  );
}

export default SetExpiryDateComplianceDocumentModal;
